/** Extra search terms by country ISO code (e.g. USA, UK, UAE). */
const COUNTRY_SEARCH_ALIASES = {
  US: ['usa', 'u.s.a', 'u.s.a.', 'u.s.', 'america', 'united states of america'],
  GB: ['uk', 'u.k', 'britain', 'great britain', 'united kingdom'],
  AE: ['uae', 'u.a.e', 'dubai', 'abu dhabi'],
  KR: ['south korea', 'republic of korea', 'korea south'],
  KP: ['north korea', 'dprk', 'korea north'],
  TW: ['taiwan', 'roc', 'republic of china'],
  HK: ['hongkong', 'hong kong sar', 'hksar'],
  MO: ['macau', 'macao'],
  CZ: ['czech republic', 'czechia'],
  CD: ['drc', 'congo kinshasa'],
  CG: ['congo brazzaville', 'republic of the congo'],
  FM: ['micronesia', 'federated states of micronesia'],
  LA: ['laos', 'lao pdr'],
  MM: ['burma', 'myanmar'],
  MD: ['moldova', 'republic of moldova'],
  MK: ['north macedonia', 'macedonia'],
  PS: ['palestine', 'palestinian territories'],
  TZ: ['tanzania', 'united republic of tanzania'],
  BO: ['bolivia', 'plurinational state of bolivia'],
  VE: ['venezuela', 'bolivarian republic of venezuela'],
  VN: ['viet nam', 'vietnam'],
  VI: ['us virgin islands', 'u.s. virgin islands', 'usvi'],
  UM: ['us minor outlying islands'],
  AS: ['american samoa'],
  GU: ['guam'],
  MP: ['northern mariana islands', 'cnmi'],
  PR: ['puerto rico'],
  RE: ['reunion'],
  SH: ['saint helena', 'st helena'],
  SJ: ['svalbard', 'jan mayen'],
  PN: ['pitcairn', 'pitcairn islands'],
  GS: ['south georgia', 'south sandwich islands'],
  EH: ['western sahara'],
  CI: ['cote divoire', 'ivory coast'],
  CV: ['cape verde', 'cabo verde'],
  BQ: ['bonaire', 'caribbean netherlands', 'sint eustatius', 'saba'],
  CW: ['curacao'],
  SX: ['sint maarten', 'st maarten'],
  MF: ['saint martin', 'st martin french'],
  BL: ['saint barthelemy', 'st barts'],
  AX: ['aland'],
  IO: ['british indian ocean territory', 'biot'],
  FK: ['falklands', 'falkland islands', 'islas malvinas'],
  GF: ['french guiana'],
  PF: ['french polynesia', 'tahiti'],
};

if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.countrySearchHaystackCache = new WeakMap();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('.country-selector__live-region'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      countrySearchHaystack(item) {
        if (this.countrySearchHaystackCache.has(item)) {
          return this.countrySearchHaystackCache.get(item);
        }
        const iso = item.dataset.value || '';
        const nameEl = item.querySelector('.country');
        const currencyEl = item.querySelector('.localization-form__currency');
        const name = nameEl ? nameEl.textContent : '';
        const currency = currencyEl ? currencyEl.textContent : '';
        const aliases = COUNTRY_SEARCH_ALIASES[iso] || [];
        const haystack = this.normalizeString([name, iso, currency, ...aliases].join(' '));
        this.countrySearchHaystackCache.set(item, haystack);
        return haystack;
      }

      countrySearchMatches(haystack, searchValue) {
        if (!searchValue) return true;
        if (searchValue.length >= 3) return haystack.includes(searchValue);
        return haystack.split(/\s+/).some((token) => token.startsWith(searchValue) || token === searchValue);
      }

      filterCountries() {
        if (!this.elements.search) return;

        const searchValue = this.normalizeString(this.elements.search.value.trim());
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('.country-selector a[data-value]');
        let visibleCount = 0;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', Boolean(searchValue));
        }

        allCountries.forEach((item) => {
          const haystack = this.countrySearchHaystack(item);
          const matches = this.countrySearchMatches(haystack, searchValue);
          item.parentElement.classList.toggle('hidden', !matches);
          if (matches) visibleCount += 1;
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.textContent = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCount
          );
        }

        const panel = this.querySelector('.country-selector');
        const list = this.querySelector('.country-selector__list');
        if (panel) panel.scrollTop = 0;
        if (list) list.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
